import { DenormalizedCustomizableGroup, DenormalizedCustomizableQuestion } from '@packages/types'
import classNames from 'classnames'
import React from 'react'

import type { BottomDrawerValues } from './../bottomDrawer/useBottomDrawer'
import SummaryDrawerStep from './SummaryDrawerStep'
import useSummaryDrawerErrorScroll from './useSummaryDrawerErrorScroll'

import './SummaryDrawerList.scss'

export type SummaryDrawerListProps = {
  drawer: BottomDrawerValues
  steps: (DenormalizedCustomizableGroup | DenormalizedCustomizableQuestion)[]
} & React.HTMLAttributes<HTMLDivElement>

const SummaryDrawerList = ({ drawer, steps, className, ...rest }: SummaryDrawerListProps) => {
  const { ref: scrollRef } = useSummaryDrawerErrorScroll({ steps })

  return (
    <div className="summary-drawer__list" ref={scrollRef}>
      <div className={classNames('summary-drawer__list-content', className)} {...rest} {...drawer.contentProps}>
        {steps.map(step => (
          <SummaryDrawerStep key={step.id} step={step} drawer={drawer} />
        ))}
      </div>
    </div>
  )
}

export default SummaryDrawerList
